module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters,
      "size": "mini",
      "id": "formCalibrationRecordsInline"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "运维公司"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择运维公司"
    },
    model: {
      value: (_vm.filters.operationcompanyId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "operationcompanyId", $$v)
      },
      expression: "filters.operationcompanyId"
    }
  }, _vm._l((_vm.operationcompanyList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "主管"
    }
  }, [_c('el-input', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "placeholder": "请输入主管"
    },
    model: {
      value: (_vm.filters.director),
      callback: function($$v) {
        _vm.$set(_vm.filters, "director", $$v)
      },
      expression: "filters.director"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "校验"
    }
  }, [_c('el-input', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "placeholder": "请输入校验"
    },
    model: {
      value: (_vm.filters.checks),
      callback: function($$v) {
        _vm.$set(_vm.filters, "checks", $$v)
      },
      expression: "filters.checks"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "校准"
    }
  }, [_c('el-input', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "placeholder": "请输入校准"
    },
    model: {
      value: (_vm.filters.calibration),
      callback: function($$v) {
        _vm.$set(_vm.filters, "calibration", $$v)
      },
      expression: "filters.calibration"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "校准仪器"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择校准仪器"
    },
    model: {
      value: (_vm.filters.devicecalibrationid),
      callback: function($$v) {
        _vm.$set(_vm.filters, "devicecalibrationid", $$v)
      },
      expression: "filters.devicecalibrationid"
    }
  }, _vm._l((_vm.deviceCailsList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.meteringutensil,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "时间范围"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "max-width": "240px"
    },
    attrs: {
      "type": "daterange",
      "picker-options": _vm.pickerOptions,
      "value-format": "yyyy-MM-dd",
      "range-separator": "-",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "align": "right"
    },
    model: {
      value: (_vm.time),
      callback: function($$v) {
        _vm.time = $$v
      },
      expression: "time"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('my-button', {
    attrs: {
      "QueryButtonShow": "",
      "AddButtonShow": "",
      "ResetButtonShow": ""
    },
    on: {
      "select-type": _vm.clickBtn
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.calibrationRecords,
      "highlight-current-row": "",
      "border": "",
      "height": _vm.formHeight,
      "size": "mini"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "devicecalibrationname",
      "label": "校准仪器"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "certificateno",
      "label": "证书号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "accuracylevel",
      "label": "准确度等级"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "director",
      "label": "主管"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "checks",
      "label": "校验"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "calibration",
      "label": "校准"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "calibrationdate",
      "label": "校准日期"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "validuntil",
      "label": "有效期至"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "校准证书"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-image', {
          staticStyle: {
            "width": "30px",
            "height": "16px"
          },
          attrs: {
            "src": "/static/query.png",
            "preview-src-list": scope.row.calibrationSrcList
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('table-update-button', {
          on: {
            "select-type": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }), _vm._v(" "), (_vm.usertype == 0) ? _c('table-delete-button', {
          on: {
            "select-type": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total, sizes, prev, pager, next, jumper",
      "page-size": _vm.pageSize,
      "total": _vm.total,
      "page-sizes": [10, 20, 30, 40, 50],
      "current-page": _vm.page
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        _vm.page = $event
      },
      "update:current-page": function($event) {
        _vm.page = $event
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.type,
      "visible": _vm.formVisible,
      "close-on-click-modal": false,
      "top": "8vh"
    },
    on: {
      "update:visible": function($event) {
        _vm.formVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "formCalibrationRecords",
    attrs: {
      "model": _vm.formCalibrationRecords,
      "label-width": "120px",
      "rules": _vm.formRules,
      "inline": true,
      "id": "formCalibrationRecords"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "校准仪器",
      "prop": "devicecalibrationid"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择校准仪器"
    },
    model: {
      value: (_vm.formCalibrationRecords.devicecalibrationid),
      callback: function($$v) {
        _vm.$set(_vm.formCalibrationRecords, "devicecalibrationid", $$v)
      },
      expression: "formCalibrationRecords.devicecalibrationid"
    }
  }, _vm._l((_vm.deviceCailsList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.meteringutensil,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "证书号",
      "prop": "certificateno"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formCalibrationRecords.certificateno),
      callback: function($$v) {
        _vm.$set(_vm.formCalibrationRecords, "certificateno", $$v)
      },
      expression: "formCalibrationRecords.certificateno"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "准确度等级",
      "prop": "accuracylevel"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formCalibrationRecords.accuracylevel),
      callback: function($$v) {
        _vm.$set(_vm.formCalibrationRecords, "accuracylevel", $$v)
      },
      expression: "formCalibrationRecords.accuracylevel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "主管",
      "prop": "director"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formCalibrationRecords.director),
      callback: function($$v) {
        _vm.$set(_vm.formCalibrationRecords, "director", $$v)
      },
      expression: "formCalibrationRecords.director"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "校验",
      "prop": "checks"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formCalibrationRecords.checks),
      callback: function($$v) {
        _vm.$set(_vm.formCalibrationRecords, "checks", $$v)
      },
      expression: "formCalibrationRecords.checks"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "校准",
      "prop": "calibration"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formCalibrationRecords.calibration),
      callback: function($$v) {
        _vm.$set(_vm.formCalibrationRecords, "calibration", $$v)
      },
      expression: "formCalibrationRecords.calibration"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "校准日期",
      "prop": "calibrationdate"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "align": "right",
      "type": "date",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.formCalibrationRecords.calibrationdate),
      callback: function($$v) {
        _vm.$set(_vm.formCalibrationRecords, "calibrationdate", $$v)
      },
      expression: "formCalibrationRecords.calibrationdate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "有效期至",
      "prop": "validuntil"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "align": "right",
      "type": "date",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.formCalibrationRecords.validuntil),
      callback: function($$v) {
        _vm.$set(_vm.formCalibrationRecords, "validuntil", $$v)
      },
      expression: "formCalibrationRecords.validuntil"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "calibrationimage",
    attrs: {
      "label": "校准证书图片",
      "prop": "calibrationimage"
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "action": "#",
      "http-request": _vm.httpRequest,
      "name": "file",
      "on-change": _vm.changeCalibration,
      "on-remove": _vm.removeCalibration,
      "accept": "image/*",
      "file-list": _vm.fileListShowCalibration,
      "list-type": "picture",
      "multiple": "",
      "auto-upload": false
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("点击上传")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传图片文件，且最好不超过500kb")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.cancleSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitData.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@11.3.4/~/vue-loader/lib/template-compiler?{"id":"data-v-bf6dfe3c"}!./~/.store/vue-loader@11.3.4/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/CalibrationRecord.vue
// module id = 1958
// module chunks = 1